import React, { useState } from 'react';

export default function ImageWithFallback({ 
  src, 
  alt, 
  className = '', 
  fallbackLogo = true,
  fallbackText = null 
}) {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  if (hasError) {
    return (
      <div className={`w-full h-48 bg-[#B49A56] flex items-center justify-center ${className}`}>
        {fallbackLogo ? (
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo-belutours-header.webp`}
            alt="BELUTOURS Logo"
            className="w-16 h-16 object-contain opacity-80"
          />
        ) : (
          <div className="text-center text-white">
            <div className="text-4xl mb-2">🏖️</div>
            <div className="text-sm font-medium">{fallbackText || 'Imagen no disponible'}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
}
